/**
 * @generated SignedSource<<60404756f26e754c65a1fed63194eaa5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SharedReportLoginInput = {
  sharedId: string;
  password: string;
  clientMutationId?: string | null;
};
export type sharedReportLoginMutation$variables = {
  input: SharedReportLoginInput;
};
export type sharedReportLoginMutation$data = {
  readonly sharedReportLogin: {
    readonly viewer: {
      readonly id: string;
    } | null;
    readonly success: boolean | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type sharedReportLoginMutation = {
  variables: sharedReportLoginMutation$variables;
  response: sharedReportLoginMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharedReportLoginPayload",
    "kind": "LinkedField",
    "name": "sharedReportLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedReportLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedReportLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e48bb19c0b44f4e6849f0b418b377251",
    "id": null,
    "metadata": {},
    "name": "sharedReportLoginMutation",
    "operationKind": "mutation",
    "text": "mutation sharedReportLoginMutation(\n  $input: SharedReportLoginInput!\n) {\n  sharedReportLogin(input: $input) {\n    viewer {\n      id\n    }\n    success\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "85245d82e62d396c1673e636b532e30a";

export default node;
